import { useEffect, useState } from 'react';

import { useDebouncedValue } from './useDebouncedValue';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const SETTLE_DELAY_MS = 800;

const isCompleteEmail = (value: string): boolean => EMAIL_PATTERN.test(value);

export const useSettledEmail = (
  email?: string | null,
  delay: number = SETTLE_DELAY_MS
): string | undefined => {
  const candidate = (email ?? '').trim();
  const debouncedCandidate = useDebouncedValue(candidate, delay);

  const [settledEmail, setSettledEmail] = useState<string | undefined>(() =>
    isCompleteEmail(candidate) ? candidate : undefined
  );

  useEffect(() => {
    if (isCompleteEmail(debouncedCandidate)) {
      setSettledEmail(debouncedCandidate);
    }
  }, [debouncedCandidate]);

  return settledEmail;
};
